import React from 'react';
import { Backdrop, CircularProgress, Container } from '@mui/material';

/**
 * Default loading spinner for the application.
 * @param {object} props Props accepted by the component.
 * @param {string} props.color The MUI theme color to use.
 * @param {boolean} props.backdrop Whether to show the MUI `Backdrop` component behind the loading spinner.
 * @param {number} props.size The size to use.
 * @param {number} props.thickness The thickness of the circle.
 * @returns {React.FunctionComponent} React element that contains the loading spinner.
 */
function LoadingSpinner({ color = 'primary', backdrop, size, thickness }) {
  return backdrop ? (
    <Backdrop
      sx={{
        height: '100%',
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open
    >
      <CircularProgress color="inherit" size={size} thickness={thickness} />
    </Backdrop>
  ) : (
    <Container
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress color={color} size={size} thickness={thickness} />
    </Container>
  );
}

export default LoadingSpinner;
